import { getPriorityOptions } from '../constants/ticket';

// خيارات فلاتر التذاكر — مشتركة بين صفحة التذاكر وصفحة التقارير عشان يبقوا نفس الشكل والقيم.
export const buildTicketFilterOptions = ({ supportSettings, tenants = [], admins = [], lang = 'ar', t, canFilterByAssignee = false }) => {
    const isAr = lang === 'ar';
    const tr = (key, ar, en) => (t ? t(key) : (isAr ? ar : en));
    const catalog = (items) => (items || [])
        .filter((item) => item?.isActive !== false)
        .map((item) => ({ label: isAr ? item.labelAr : item.labelEn, value: item.key, lang }));

    const assignee = [
        { label: isAr ? 'الكل' : 'All', value: 'all', lang },
        { label: isAr ? 'غير معيّنة' : 'Unassigned', value: 'unassigned', lang },
        ...(admins || []).map((admin) => ({
            label: admin?.name || admin?.username || admin?._id || '',
            value: admin?._id,
            lang,
            subLabel: admin?.jobTitle || '',
            avatar: admin?.userPic || admin?.avatar || admin?.image || admin?.profileImage || admin?.photo || ''
        }))
    ];

    return {
        product: [
            { label: tr('support.tickets.allProducts', 'كل الخدمات / المنتجات', 'All Products'), value: 'all', lang },
            ...catalog(supportSettings?.products),
        ],
        section: [
            { label: tr('support.tickets.allSections', 'كل الأقسام', 'All Sections'), value: 'all', lang },
            ...catalog(supportSettings?.sections),
        ],
        priority: [
            { label: isAr ? 'كل الأولويات' : 'All priorities', value: 'all', lang },
            ...getPriorityOptions(lang),
        ],
        tenantId: [
            { label: isAr ? 'كل العملاء' : 'All Customers', value: 'all', lang },
            ...(tenants || []).map((tenant) => ({
                label: tenant?.tenantName || tenant?.username || tenant?._id || '',
                value: tenant?._id,
                lang
            }))
        ],
        visibility: [
            { label: isAr ? 'كل الأنواع' : 'All Types', value: 'all', lang },
            { label: isAr ? 'داخلي' : 'Internal', value: 'internal', lang },
            { label: isAr ? 'خارجي' : 'External', value: 'external', lang },
        ],
        // لو مش مسموح بفلتر المعيّن بنشيل "الكل / غير معيّنة" ونسيب الأسماء بس (بتتستخدم لعرض الأسماء في الجدول).
        assignee: canFilterByAssignee ? assignee : assignee.slice(2),
    };
};

export const TICKET_FILTER_KEYS = ['product', 'section', 'priority', 'tenantId', 'visibility', 'assignee'];
